import React from 'react';
import gallery1 from '../../assets/images/gallery.jpg';
import gallery2 from '../../assets/images/gallery1.jpg';
import gallery3 from '../../assets/images/gallery2.jpg';
import gallery4 from '../../assets/images/gallery3.jpg';
import gallery5 from '../../assets/images/gallery4.jpg';
import gallery6 from '../../assets/images/gallery5.jpg';
import gallery7 from '../../assets/images/gallery6.jpg';
import gallery8 from '../../assets/images/gallery7.jpg';
import gallery9 from '../../assets/images/gallery8.png';
import gallery10 from '../../assets/images/gallery9.png';
import gallery11 from '../../assets/images/gallery10.png';
import gallery12 from '../../assets/images/gallery11.png';
import gallery13 from '../../assets/images/gallery12.png';
import gallery14 from '../../assets/images/gallery13.png';
import gallery15 from '../../assets/images/gallery14.png';
import gallery16 from '../../assets/images/gallery15.png';
import gallery17 from '../../assets/images/gallery16.png';

const images = [
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  gallery16,
  gallery17,
];

const Gallery = () => {
  return (
    <section className='gallery-one'>
      <div className='container'>
        <div className='row'>
          {images.map((image, index) => (
            <div
              className='col-lg-4 col-md-6 col-sm-12 gallery-item'
              key={index}
            >
              <img
                className='gallery-image'
                src={image}
                alt={`Gallery ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
